class SocialShare {
    constructor($el) {
        this.$el = $el;

        if(this.$el) {
            this.init();
        }
    }

    init() {
        this.$socialLinks = this.$el.querySelectorAll('.share-button');

        if(this.$socialLinks.length) {
            this._bindEvents();
        }
    }

    _bindEvents() {
        this.onShareFn = this._onShare.bind(this);
        this.$socialLinks.forEach((link) => {
            link.addEventListener('click', this.onShareFn);
        });

    }
    _onShare(e) {
        e.preventDefault();

        const $target = e.target;

        console.log($target);

            if($target.classList.contains('share-twitter')) {
                window.open($target.getAttribute('href'), 'Twitter', 'height=300,width=550,resizable=1');
            }
            else if($target.classList.contains('share-facebook')) {
                window.open($target.getAttribute('href'), 'Facebook', 'height=300,width=550,resizable=1');
            }
            else if($target.classList.contains('share-linkedin')) {
                window.open($target.getAttribute('href'), 'LinkedIn', 'height=606,width=586,resizable=1');
            }
    }
}
export default SocialShare;
